import { useIds as y } from "@chakra-ui/hooks";
import { mergeRefs as g } from "@chakra-ui/react-utils";
import { callAllHandlers as k } from "@chakra-ui/utils";
import { useRef as C, useState as e, useCallback as R } from "react";
function D({ id: l }) {
  const [i, o, t] = y(
    l,
    "odi-section",
    "odi-section--title",
    "odi-section--description"
  ), s = C(null), [n, r] = e(!1), [d, a] = e(!1), [u, f] = e(!1), [p, m] = e(!1), M = R(
    (c = {}, b = null) => ({
      ...c,
      ref: g(b, s),
      id: i,
      tabIndex: -1,
      "aria-labelledby": n ? o : void 0,
      "aria-describedby": d ? t : void 0,
      onClick: k(
        c.onClick,
        (I) => I.stopPropagation()
      )
    }),
    [t, d, i, o, n]
  );
  return {
    titleId: o,
    descriptionId: t,
    isBodyMounted: u,
    isFooterMounted: p,
    setTitleMounted: r,
    setDescriptionMounted: a,
    setBodyMounted: f,
    setFooterMounted: m,
    sectionRef: s,
    getSectionProps: M
  };
}
export {
  D as useSection
};
